var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._b({attrs:{"value":_vm.inputV},on:{"input":_vm.input}},'el-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }